import {
  ACTIVITY_TYPE_LABELS,
  OBSERVATION_SOURCE_LABELS,
  TRACKED_COMPETITION_STATUS_LABELS,
  type ActivityType,
  type ObservationConfidence,
  type ObservationSource,
  type TrackedCompetitionStatus,
} from '@/api/market'
import { Badge, type BadgeTone } from '@/design'

const STATUS_TONE: Record<TrackedCompetitionStatus, BadgeTone> = {
  upcoming: 'info',
  live: 'positive',
  closing_soon: 'warning',
  closed: 'neutral',
}

export function TrackedStatusBadge({ status }: { status: TrackedCompetitionStatus }) {
  return <Badge tone={STATUS_TONE[status]}>{TRACKED_COMPETITION_STATUS_LABELS[status]}</Badge>
}

const ACTIVITY_TONE: Record<ActivityType, BadgeTone> = {
  launch: 'accent',
  closing_soon: 'warning',
  price_change: 'info',
  category_trend: 'accent',
  other: 'neutral',
}

export function ActivityTypeBadge({ activityType }: { activityType: ActivityType }) {
  return <Badge tone={ACTIVITY_TONE[activityType]}>{ACTIVITY_TYPE_LABELS[activityType]}</Badge>
}

const SOURCE_TONE: Record<ObservationSource, BadgeTone> = {
  manual: 'neutral',
  import: 'info',
  monitor: 'warning',
}

export function SourceBadge({ source }: { source: ObservationSource }) {
  return <Badge tone={SOURCE_TONE[source]}>{OBSERVATION_SOURCE_LABELS[source]}</Badge>
}

const CONFIDENCE_TONE: Record<ObservationConfidence, BadgeTone> = {
  high: 'positive',
  medium: 'warning',
  low: 'neutral',
}

const CONFIDENCE_LABEL: Record<ObservationConfidence, string> = {
  high: 'High confidence',
  medium: 'Medium confidence',
  low: 'Low confidence',
}

export function ConfidenceBadge({ confidence }: { confidence: ObservationConfidence }) {
  return <Badge tone={CONFIDENCE_TONE[confidence]}>{CONFIDENCE_LABEL[confidence]}</Badge>
}
